module.exports = __webpack_public_path__ + "img/damnn_group_header.d07e860a.png";